import SentimentTracker from './sentiment-tracker'

export default SentimentTracker
